// src/components/tabs/OverviewTab.jsx
import React from 'react';

function OverviewTab({ movie }) {
  if (!movie) return <div>No movie selected</div>;

  const posterPath = movie.poster_path 
    ? `https://image.tmdb.org/t/p/w500${movie.poster_path}`
    : '/placeholder-poster.jpg';
    
  const backdropPath = movie.backdrop_path
    ? `https://image.tmdb.org/t/p/original${movie.backdrop_path}`
    : '/placeholder-backdrop.jpg';
    
  return (
    <div className="overview-tab">
      <div className="backdrop" style={{ backgroundImage: `url(${backdropPath})` }}>
        <div className="backdrop-overlay"></div>
      </div>
      
      <div className="movie-content">
        <div className="poster-container">
          <img src={posterPath} alt={`${movie.title} poster`} className="movie-poster" />
        </div>
        
        <div className="movie-details">
          <h1>{movie.title}</h1>
          
          <div className="movie-meta">
            <span>{movie.release_date ? new Date(movie.release_date).getFullYear() : 'Unknown'}</span>
            <span>{movie.runtime ? `${movie.runtime} min` : ''}</span>
            <span>{movie.genres?.join(', ')}</span>
            <span className="rating">{movie.vote_average?.toFixed(1)}/10</span>
          </div>
          
          <div className="movie-summary">
            <h2>Summary</h2>
            <p>{movie.summary || movie.overview}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OverviewTab;